// extracted by mini-css-extract-plugin
export default {"root":"NqZRSnaVu2yuQZnOG9u4","job-submitted":"bIc7yNmMv07KA8TKiicT"};